<template>
   <el-container  style="display: block;background-color: #ffffff;" :style="{'width':screenWidth+'px','height':screenHeight+'px'}">

     <el-row :span="2" style="margin-top: 30px;margin-left: 10%;">



         <el-row :span="2" style="margin-top: 30px;">
             <el-col :span="2">
               <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
             </el-col>
             <el-col :span="3">
               <el-button type="primary" style="background-color: #409eff;" @click="del()" round>一键清空</el-button>
             </el-col>
         </el-row>
     </el-row>
     <div :style="{'width':screenWidth,'height':screenHeight}" style="display: flex;flex-wrap: wrap;overflow-y: scroll;background-color: #fff;">
      <el-row   style="margin-top: 30px;margin-left: 10%;overflow-y: scroll;border: 1px solid #000000;" :style="{'width':screenWidth*0.7+'px','height':screenHeight*0.8+'px'}">
        <h2 style="text-align: center;">详细内容</h2>
        <ul style="color: #000000;width: 100%;overflow-y: scroll;margin-left: 15px;">

          <li v-for="(item, index) in list" :key="index" style="font-family: 'hanyi';" @click="dischange(item['name'],item['id'])">{{item['name']}}</li>


        </ul>
      </el-row>





     </div>


    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
   <el-dialog
     title="添加"
     :visible.sync="centerDialogVisible"
     width="50%"
     center>
     <el-input
       type="textarea"
       :rows="20"
       style="height: 500px;"
       :style="{'height': screenHeight*0.4+'px'}"
       placeholder="请输入内容"
       v-model="addT">
     </el-input>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="centerDialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="doAdd()">确 定</el-button>
     </span>
   </el-dialog>
   <el-dialog
     title="提示"
     :visible.sync="dialogVisible"
     width="30%"
     >
     <span>确认清空？</span>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="dialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="doDell()">确 定</el-button>
     </span>
   </el-dialog>
   <el-dialog
     title="修改"
     :visible.sync="disDialogVisible"
     width="70%"
     center>
     <input type="text" class="searchT" style="width: 100%;" v-model="names"/>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="disDialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="dodisChange()">确 定</el-button>
     </span>
   </el-dialog>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        dialogVisible:false,
        centerDialogVisible:false,
        disDialogVisible:false,
        changeId:0,
        t:0,
        names:'',
        list:[],
        addT:'',
        id:this.$route.query.id,
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-20)/20,
        vheight : window.innerHeight/200,

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()




    },

	methods:{
    dischange(name,id){
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_text_Changes'
      })
      .then(res=>{
        this.disDialogVisible = false
        this.loadList()



      })
      .catch(err=>{

      });
    },
    del(){
      this.dialogVisible = true
    },
    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.id,

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_text_dels'
      })
      .then(res=>{
        this.msg('清理成功','success');
        this.dialogVisible = false
        this.loadList()
      })
      .catch(err=>{

      });

    },
    add(){
      this.addT = ''
      this.centerDialogVisible = true
      // var dd = ''
      // var cc = this.list.length - 1
      // this.list.forEach(function(item, index) {
      //    if(index == cc){
      //      dd = dd + item['name']
      //    }else{
      //      dd = dd + item['name']+'\n'
      //    }

      // })
      // this.addT = dd
    },
    doAdd(){
      var data = this.addT.split('\n')
      var huiying = data.join(',')
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.id,
          names:huiying
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanli_text_edit'
      })
      .then(res=>{
        this.msg('编辑成功','success');
        this.centerDialogVisible = false
        this.addT = ''
        this.loadList()
      })
      .catch(err=>{

      });

    },
    toPage(id){
      this.$router.push('/shop2?id='+id);
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

          id:this.id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/shopGuanli_text_list'
      })
      .then(res=>{
        this.list = res.data.list;

        // console.log(this.list)


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;

}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  /* .el-scrollbar__wrap{
    background-color: black;
  } */
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shopvideot.vue